module.exports = __webpack_public_path__ + "media/images/smart_phone/item/btn_back_ov-9564133655519a5ae6c5eb7d76b8b5f1.png";